import React from 'react'
import {BaseButton, Box, Text} from '../../../../vanilla'
import { useRapidDeliveryStore } from '../../../../store/hooks/useStore'
import { RapidLabelIcon } from '../../../../components/icons'

export const RapidDeliveryPrompt = () => {
  const { rapidDeliveryDeliveryEstimate } = useRapidDeliveryStore()
  return (
    <Box
      id="rapid-delivery-prompt"
      data-test-selector="rapid-delivery-prompt"
      backgroundColor="white"
      paddingX={["16px", "28px"]}
      paddingY="16px"
      marginTop="12px"
    >
      <Box display={["block", "flex"]} alignItems="center">
        <Box display="flex" alignItems="center" gap="16px" flex="1">
          <RapidLabelIcon height="30px" width="auto" flexShrink="0" data-test-selector="rapid-delivery-icon" />
          {/* Only show 'Rapid Delivery' on larger screens */}
          <Text variant="unstyled" style={{fontSize: '18px', fontWeight: 600}} color='gray1000' display={["none", "block"]} >
            Rapid Delivery
          </Text>

          <Box marginLeft={["0px", "auto"]} display={["block", "flex"]} alignItems="center">
            <Text
              variant="text6"
              fontWeight="bold"
              lineHeight="short"
              marginRight={["0px", "6px"]}
              data-test-selector="rapid-delivery-prompt-heading"
            >
              Need your shopping in a hurry?
            </Text>
            <Text variant="text3" lineHeight="short" data-test-selector="rapid-delivery-prompt-estimate">
              {/* Fallback to 60 minutes if rapidDeliveryDeliveryEstimate is not available */}
              Deliveries in under {rapidDeliveryDeliveryEstimate ?? 60} minutes.
            </Text>
          </Box>
        </Box>

        <BaseButton
          size="sm"
          variant="outlinePrimary"
          maxHeight="40px"
          width={["full", "auto"]}
          marginTop={["12px", "0px"]}
          marginLeft={["0px", "16px"]}
          data-test-selector="rapid-delivery-prompt-book-button"
        >
          <Text variant="text6" paddingX="20px">
            Book Rapid
          </Text>
        </BaseButton>
      </Box>
    </Box>
  )
}